import { ServiceContext } from 'utilities/service.utils';

const OriginalService = new ServiceContext(undefined, {});

export default OriginalService;
